import React from 'react';

export default () => {
  return (
    <div className="mx-auto w-[400px] pb-[200px] pt-[90px] text-center">
      <h1 className="mb-[70px] text-center text-[26px] font-medium text-neutral-700">
        パスワード変更完了
      </h1>

      <div className="mb-10 mt-5 text-xs leading-[1.5] text-neutral-900 [&_p]:mb-0">
        <p>パスワードの変更が完了しました。</p>
      </div>
    </div>
  );
};
